function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, createRef } from 'react';
import PropTypes from 'prop-types';
import Status from '../Status';
import Label from '../Label';
import { Container, InputElement } from './elements';
/**
 * Gets status name from status flags.
 *
 * @param {loading} loading - Loading flag.
 * @param {boolean} info - Info flag.
 * @param {boolean} success - Success flag.
 * @param {boolean} warning - Warning flag.
 * @param {error} error - Error flag.
 * @param {search} search - Search flag.
 *
 * @return The status.
 */

var getStatus = function getStatus(loading, info, success, warning, error, search) {
  if (loading) return 'loading';
  if (info) return 'info';
  if (success) return 'success';
  if (warning) return 'warning';
  if (error) return 'error';
  if (search) return 'search';
};
/**
 * Defines a text input. Extra datas can be added, such as an Icon, or plain text, that will both be displayed
 * either on the left or on the right of the actual text input.
 * Custom styles to inform about the status of the input (convenient if used in a form) or its purpose
 * can also be added through the props available on the TextInput.
 *
 * @returns {jsx}
 */


var TextInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(TextInput, _PureComponent);

  var _super = _createSuper(TextInput);

  function TextInput() {
    var _this;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "inputRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      // Used for displaying the value in the "native" input (inner input).
      // If the component is used by default, this state is updated by the "native" input. If the
      // component is a controlled component, this value is managed by the user.
      value: _this.props.value,
      // eslint-disable-line react/destructuring-assignment
      // State to bubble up focus from "native" input to the whole container.
      hasFocus: false,
      // Keeps track of the cursor's position for controlled input.
      cursorPosition: 1
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          propValue = _this$props.value,
          onChange = _this$props.onChange;
      var _e$target = e.target,
          eventValue = _e$target.value,
          cursorPosition = _e$target.selectionStart;

      if (!disabled) {
        // We constrained to check for nullity since its the only mean to actually ensure that no
        // value was given via prop.
        var value = propValue == null ? eventValue : propValue;

        _this.setState({
          value: value,
          cursorPosition: cursorPosition
        }, function () {
          onChange(eventValue);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      var _this$props2 = _this.props,
          onFocus = _this$props2.onFocus,
          _onFocus = _this$props2._onFocus;

      _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        hasFocus: true
      }), function () {
        onFocus();

        _onFocus();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      var _this$props3 = _this.props,
          onBlur = _this$props3.onBlur,
          _onBlur = _this$props3._onBlur;

      _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        hasFocus: false
      }), function () {
        onBlur();

        _onBlur();
      });
    });

    return _this;
  }

  _createClass(TextInput, [{
    key: "componentDidUpdate",
    value:
    /**
     * Handles update of component.
     *
     * This method checks whether the value has changed and eventually updates the cursor's position
     * of the native input.
     *
     * @param {Object} prevProps - The previous component's props.
     */
    function componentDidUpdate(prevProps) {
      var _this2 = this;

      var value = this.props.value;

      if (value !== prevProps.value) {
        this.setState({
          value: value
        }, function () {
          var cursorPosition = _this2.state.cursorPosition;
          _this2.inputRef.selectionStart = cursorPosition;
          _this2.inputRef.selectionEnd = cursorPosition;
        });
      }
    }
    /**
     * Handles change of value in "native" input.
     *
     * @param {Object} e - The native event.
     */

  }, {
    key: "render",
    value:
    /**
     * Renders the component.
     *
     * @return {jsx}
     */
    function render() {
      var _this3 = this;

      var _this$state = this.state,
          value = _this$state.value,
          hasFocus = _this$state.hasFocus;
      var _this$props4 = this.props,
          className = _this$props4.className,
          width = _this$props4.width,
          fluid = _this$props4.fluid,
          id = _this$props4.id,
          tabIndex = _this$props4.tabIndex,
          placeholder = _this$props4.placeholder,
          disabled = _this$props4.disabled,
          label = _this$props4.label,
          labelPosition = _this$props4.labelPosition,
          loading = _this$props4.loading,
          info = _this$props4.info,
          ghost = _this$props4.ghost,
          success = _this$props4.success,
          warning = _this$props4.warning,
          error = _this$props4.error,
          search = _this$props4.search,
          type = _this$props4.type; // We want to display loading status whether the input is disabled or not.
      // Other status are however omited in case the input is disabled.

      var hasStatus = loading || !disabled && (success || info || warning || error || search);
      return /*#__PURE__*/React.createElement(Container, {
        className: className,
        width: fluid ? '100%' : width,
        hasFocus: hasFocus,
        disabled: disabled,
        info: info,
        success: success,
        warning: warning,
        error: error,
        ghost: ghost,
        "data-testid": "input-container"
      }, label && labelPosition === 'left' && /*#__PURE__*/React.createElement(Label, {
        label: label,
        position: "left"
      }), /*#__PURE__*/React.createElement(InputElement, {
        "data-testid": "input",
        ref: function ref(_ref) {
          return _this3.inputRef = _ref;
        },
        type: type,
        id: id,
        tabIndex: tabIndex,
        value: value || '',
        placeholder: placeholder,
        disabled: disabled,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }), hasStatus && /*#__PURE__*/React.createElement(Status, {
        hasFocus: hasFocus,
        status: getStatus(loading, info, success, warning, error, search)
      }), label && labelPosition === 'right' && /*#__PURE__*/React.createElement(Label, {
        label: label,
        position: "right"
      }));
    }
  }]);

  return TextInput;
}(PureComponent);

var bool = PropTypes.bool,
    func = PropTypes.func,
    oneOf = PropTypes.oneOf,
    shape = PropTypes.shape,
    string = PropTypes.string;
/** Display name. */

TextInput.displayName = 'TextInput';
/** Props types validation. */

TextInput.propTypes = {
  /**
   * className needed by styled components
   */
  className: string,

  /**
   * Whether the input is disabled or not
   */
  disabled: bool,

  /**
   * Whether the input has error status
   */
  error: bool,

  /**
   * Whether the input takes all available space or not
   */
  fluid: bool,

  /**
   * Whether to display an input without border
   */
  ghost: bool,

  /**
   * ID of the input in the DOM
   */
  id: string,

  /**
   * Whether the input has info status
   */
  info: bool,

  /**
   * Object defining the label with either `icon` with the name of the icon to display, or
   * `text` with the text to display
   */
  label: shape({
    icon: string,
    text: string
  }),

  /**
   * Position of label (`left` or `right`)
   */
  labelPosition: oneOf(['left', 'right']),

  /**
   * Whether the input has loading status
   */
  loading: bool,

  /**
   * Handler when input loses focus
   */
  onBlur: func,

  /**
   * Handler on input value change
   */
  onChange: func,

  /**
   * Handler when input gains focus
   */
  onFocus: func,

  /**
   * placeholder text
   */
  placeholder: string,

  /**
   * Whether the input has search status
   */
  search: bool,

  /**
   * Whether the input has success status
   */
  success: bool,

  /**
   * The tabulation index of the input in its parent form.
   */
  tabIndex: string,

  /**
   * Type of the text input
   */
  type: oneOf(['password', 'text']),

  /**
   * Value of the text input
   */
  value: string,

  /**
   * Whether the input has warning status
   */
  warning: bool,

  /**
   * The width of the input as a string (includes either 'px' or 'rem')
   */
  width: string,

  /**
   * Internal handler when input gains focus
   */
  _onFocus: func,

  /**
   * Internal handler when input loses focus
   */
  _onBlur: func
};
/** Default props. */

TextInput.defaultProps = {
  className: '',
  disabled: false,
  error: false,
  fluid: false,
  ghost: false,
  id: '',
  info: false,
  label: null,
  labelPosition: 'left',
  loading: false,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  placeholder: '',
  search: false,
  success: false,
  tabIndex: '0',
  type: 'text',
  value: null,
  width: '25rem',
  warning: false,
  _onBlur: function _onBlur() {},
  _onFocus: function _onFocus() {}
};
export default TextInput;